import { render, staticRenderFns } from "./QuoteRangesSettings.vue?vue&type=template&id=06433b1f&"
import script from "./QuoteRangesSettings.vue?vue&type=script&lang=js&"
export * from "./QuoteRangesSettings.vue?vue&type=script&lang=js&"
import style0 from "./QuoteRangesSettings.vue?vue&type=style&index=0&id=06433b1f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports